module.exports = __webpack_public_path__ + "static/media/Team 31 - IngredAble.1680c75a.png";